import React, {
  MouseEvent,
} from 'react';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import {
  formatPhone,
} from '@populateui/utils';
import clsx from 'clsx';

type Props = {
  phoneNumberWithAreaCode: string;
  className?: string;
};
export default function PhoneLink({
  phoneNumberWithAreaCode,
  className = '',
}: Props) {
  return (
    <a
      onClick={(e: MouseEvent<HTMLAnchorElement>) => { e.stopPropagation(); }}
      href={`tel:${phoneNumberWithAreaCode}`}
      className={clsx('nw-phone-number hover:text-blue-500 group/phone', className)}
    >
      <PhoneRoundedIcon
        className="!transition-all !ease-in-out duration-200 !w-4 !h-4 text-gray-600 mr-2 rotate-[135deg] group-hover/phone:rotate-0 text-inherit"
      />
      {formatPhone(phoneNumberWithAreaCode ?? '')}
    </a>
  );
}
